// RW.js

import React from 'react';
import './RW.css'; // Import the CSS file

const RW = () => {
  return (
    <div className="cladding-container">
      <h1>Roof and Wall Cladding: Elevating the Aesthetics of Steel Structures</h1>
      <p>This segment revolves around the integration of roof and wall cladding, contributing significantly to the visual allure of steel constructions.</p>
      
      <h2>In-Depth Look at the Cladding Structure System</h2>
      
      <ul>
        <li>The foundational steel sheet undergoes a galvanization process, meticulously following the ASTM A792M/JIS G3321:2021 standard. Engineered with a robust strength ranging from 300 to 550, it is further enhanced by an aluminum coating conforming to the ASTM B 209M Alloy 3003 Temper H26 standard.</li>
        <li>Notably, the aluminum coating constitutes a substantial 55%, while the remaining 45% is attributed to a zinc coating, carefully calibrated to achieve an optimal balance in total coating weight.</li>
        <li>The exterior surface of the steel sheet boasts a meticulous application of a high-quality polyester paint layer, measuring a substantial 25 microns in thickness. This layer serves not only an aesthetic purpose but also adds a protective dimension to the 25-micron thick steel sheet.</li>
        <li>Meanwhile, the inner surface undergoes a similar treatment, featuring a 10-micron thick high-quality polyester paint layer. This dual-layered approach ensures both external resilience and internal longevity for the 10-micron thick steel sheet.</li>
     
      </ul>
    </div>
  );
}

export default RW;
